import React, { Component, PropTypes } from 'react';

import './AddItem.css';

class AddItem extends Component {
  static propTypes = {
    addItem: PropTypes.func.isRequired
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.inputRef.value) {
      return;
    }

    this.props.addItem(this.inputRef.value);
    this.inputRef.value = '';
  }

  setInputRef = ref => this.inputRef = ref

  render() {
    return (
      <form className="AddItem" onSubmit={this.handleSubmit}>
        <input type="text" placeholder="Add Item" autoCapitalize="none" ref={this.setInputRef}/>
      </form>
    );
  }
}

export default AddItem;



/** WEBPACK FOOTER **
 ** ./src/components/AddItem.js
 **/